"use client";

import { useTranslations } from "next-intl";

import { CategoryExploreList } from "../audio/CategoryExploreList";
import type { CategoryExploreListProps, SoundEffectExploreItem } from "../audio/CategoryExploreList";

type SoundEffectsExploreListProps = Omit<CategoryExploreListProps, "labels">;

function SoundEffectsExploreList(props: SoundEffectsExploreListProps) {
  const tGlobals = useTranslations("ClientKeys.Globals");
  const t = useTranslations("ClientKeys.SoundEffectsExploreList");
  return (
    <CategoryExploreList
      {...props}
      labels={{
        headerCountSuffix: tGlobals("sound_effects"),
        generateCtaDefaultLabel: t("generate_your_own_sound_effects"),
      }}
    />
  );
}

SoundEffectsExploreList.displayName = "SoundEffectsExploreList";

export { SoundEffectsExploreList };
export type { SoundEffectExploreItem, SoundEffectsExploreListProps };
